export default __webpack_public_path__ + "8b45a5a28f750b8c7d94f9f4938608bf.png";